import React from 'react';
import Modal from '../common/Modal';
import HomeContentBoxModal from './HomeContentBoxModal';
import HomeContentBox from './HomeContentBox';
import _ from 'lodash';

export default class HomeContentBoxesContainer extends React.Component {

    state = {
        modalBox: null
    }

    render() {
        let contentBoxColumns = [
            [], [], []
        ];

        this.props.contentBoxes.forEach(box => {
            switch (box.position) {
                case 'Left': {
                    contentBoxColumns[0].push(box);
                    break;
                }

                case 'Middle': {
                    contentBoxColumns[1].push(box);
                    break;
                }

                case 'Right': {
                    contentBoxColumns[2].push(box);
                    break;
                }
            }
        });

        return (
            <div className="page-container">
                <div className="homepage-content-boxes">
                    {contentBoxColumns.map((column, columnIndex) => (
                        <div key={columnIndex} className="homepage-content-boxes-column">
                            {_.orderBy(column, ['order', 'asc']).map((box, boxIndex) => (
                                <HomeContentBox key={boxIndex} box={box} openInModalClick={this.openInModalClick}/>
                            ))}
                        </div>
                    ))}
                </div>
                {this.renderModal()}
            </div>
        );
    }

    openInModalClick = modalBox => {
        this.setState({
            modalBox
        })
    }

    onCloseModal = () => {
        this.setState({
            modalBox: null
        })
    }

    renderModal = () => {
        if (!this.state.modalBox) {
            return <React.Fragment/>
        }

        return (
            <Modal class="content-box-modal" isOpen={this.state.modalBox !== null} onClose={this.onCloseModal}>
                <Modal.Body>
                    <div className="homepage-content-boxes">
                        <HomeContentBoxModal box={this.state.modalBox} onCloseClick={this.onCloseModal}/>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}